import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  Pipe,
  PipeTransform,
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs";
import { EventsUtils } from "./EventsUtils";

import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";

import { PDFfile } from "src/app/device/PDFfile";
import { Router } from "@angular/router";
import { TraslateService } from "src/app/traslate.service";

import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";
import { MatAccordion } from "@angular/material/expansion";
import { LabelType, Options } from "@angular-slider/ngx-slider";
import { MatDialog } from "@angular/material/dialog";

export type ChartOptions = {
  series: any;
  chart: any;
  xaxis: any;
  yaxis: any;
  title: any;
  fill: any;
  dataLabels: any;
  tooltips: any;
  annotations: any;
  stroke: any;
  markers: any;
  colors: string[];
  grid: any;
  legend: any;
};

export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}
@Pipe({ name: "formatTime" })
export class FormatTime implements PipeTransform {
  transform(value: number): string {
    let minutes: number = Math.trunc(value / 60);
    let hours: number = 0;
    let seconds: number = value - minutes * 60;

    if (minutes >= 60) {
      hours = Math.trunc(minutes / 60);
      minutes = minutes - hours * 60;
    }

    let response: string = "";

    if (hours > 0) {
      response = response + hours + " h ";
    }

    if (minutes > 0) {
      response = response + minutes + " min ";
    }

    if (seconds > 0) {
      response = response + seconds + " sec";
    }

    return response;
  }
}

export interface dataRep {
  label: number;
  value: number;
}

export interface dataRep2 {
  value: number;
}

@Component({
  selector: "app-events",
  templateUrl: "./events.component.html",
  styleUrls: ["./events.component.scss"],
})
export class EventsComponent implements OnInit {
  withFiltre=false;
  value1: number = 1;
  minValue: number = 0;
  maxValue: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100,
    step: 1,

    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return "Min score" + value + "%";
        case LabelType.High:
          return "Max score" + value + "%";
        default:
          return value + "%";
      }
    },
  };
  list
  options1: Options = {
    showTicksValues: true,
    step: 1,
    stepsArray: [
      { value: 1, legend: "Accident" },
      { value: 2, legend: "Accélération" },
      { value: 3, legend: "Freinage" },
      { value: 4, legend: "Virage" },
      { value: 5, legend: "Excès de vitesse" },
      { value: 6, legend: "Franchissement de ligne" },
      { value: 7, legend: "Inactivité" },
      { value: 8, legend: "Virage et freinage" },
      { value: 9, legend: "Virage et accélération" },
    ],
    getPointerColor: (value: number): string => {
      if (value <= 8) {
        return "#f44336";
      }
      if (value <= 13) {
        return "#ffe041";
      }
      if (value <= 16) {
        return "#4492c7";
      }
      return "#2AE02A";
    },
  };
  toppings = new FormControl();
  toppingList : { value: number, typeVehicule: string }[]= []


  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();
  myModel = false;
  chartOptions16: any;
  chartOptions17: any;
  manualPage: number = 0;
  pageSize1: any;
  pageSize = 15;
  // pageSize = "element";

  lengthpage: number;
  pageNum: any;
  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  public dateTime: Date;
  index2: any = 10;
  dd: any = 0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  itemSelect2: any;
  hiddenContenu: string = "false";
  range: string;
  filterValue: string;
  repos2: PeriodicElementfilter[];
  URL: RequestInfo;
  refrech1: number = 2017;
  dt: any;
  offsetPagination: any = 0;
  days: any;
  finalDate: any;
  dataSource: MatTableDataSource<any>;
@ViewChild(MatPaginator) paginator!: MatPaginator;
@ViewChild(MatSort) sort!: MatSort;
  hiddenDetails: boolean = false;
  dtformt: string = "M/d/yyyy";
  jj: string;
  tblhidden: string;
  typeMessage: string;
  dataSourcee: any;
  ELEMENT_DATAFILTER: PeriodicElementfilter[];
  getdt: string;
  panelOpenState = false;
  repos: any;
  reposdt: any;
  ELEMENT_DATAFILTER2: any;
  URL2: string;
  currentScore: any;
  type9: string;
  width9: string;
  height9: string;
  dataSource9: any;
  dataFetch: (string | number)[][];

  ELEMENTSCORE: dataScore[];
  xValues: any;
  series2: any[];
  customColors2: any;

  chartOptions: any;
  chartOptions2: any;
  chartOptions3: any;

  chartOptions4: any;
  chartOptions5: any;

  series1: any = [];
  ff: any = null;

  series3: any = [];
  series4: any = [];
  fff: any = [];
  vv: any;
  yValues: any;
  evolutionScoreEconomie: boolean;
  evolutionScoreSecurite: boolean;
  typeEvenement: boolean;
  relationSecuriteEconomie: boolean;
  repartitionScoreSecurite: boolean;
  repartitionScoreEconomie: boolean;
  testFilter1: number;
  testFilter11: number;
  showevents: boolean;
  location: any;
  result: any[];
  @ViewChild(MatAccordion) accordion: MatAccordion;
  valueLegende: string;
  dateFiltrer: any;
  response:{
    data: any;
  }
  refModel: any;

  goToBottom(e) {
    //console.log(document.body.scrollHeight)
    /*   window.scroll({
         top: e,
         left: 0,
         behavior: 'smooth'
       });*/
  }

  rangeForm: FormGroup = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });

  ngOnInit(): void {
    // this.updateManualPage2(this.index2);

    this.getUserrefrech(15,1);
    this.toppingList= [
      { value: 5, typeVehicule: "Privé" },
      { value: 3, typeVehicule: "Bus" },
      { value: 2, typeVehicule: "Camionette" },
      { value: 4, typeVehicule: "Grand camion" },
      { value: 1, typeVehicule: "Petit camion" },
    ];
  }

  showFiltrage(filtrage) {
    this.refModel =this.refDialog.open(filtrage, {
      width: "100%",
      height: "500px",
    });
  }
  getUserrefrech(currentSize ,offset) {
    //this.idMan = this.location.path().split('/')[4]
    ////console.log(this.idVehicule)
     console.log("fatiha")
    this.result = [];
    //console.log(this.result)
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.typeEvenement = false;
    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/maneuvers"+ '?page='+ offset

    this.showevents = true;
    this.spinnerevents.show();
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        this.itemSelect = [];
        // var list: any = (<any>response).data;
        console.log("listData:",(<any>response).data);
        this.hiddenDetails = false;
        this.selectedRowIndex = -1;
        // @ts-ignore
        this.list=response?.data
          // @ts-ignore
        this.list.length=response?.total
        this.dataSource = new MatTableDataSource(this.list);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.lengthTotal = (<any>response).total
        // this.Itemss =list.drivers.data
        // if (currentSize == 0 ){
        //   list.length =15 ;
        // }else {
        //   list.length =currentSize ;
        // }

        this.spinnerevents.hide();
        this.showevents = false;
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });

        this.spinnerevents.hide();
        this.showevents = false;
      }
    );
  }

  displayedColumns: string[] = [
    "unit",
    "driver",
    "maneuver_type",
    "risk_score",
    "maneuver_start",
    "maneuver_end",
    "maneuver_duration",
    "avg_speed",
    "max_speed",
  ];
  // Assign the data to the data source for the table to render

  pipe: DatePipe;

  constructor(
    public refDialog: MatDialog,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private router: Router,
    public traslateService: TraslateService,
    private http: HttpClient,
    private spinnerevents: NgxSpinnerService
  ) {
    this.rangeForm = new FormGroup({
      start: new FormControl(new Date()),
      end: new FormControl(new Date()),
    });

    this.series1 = [];
    this.traslateService.obs.subscribe((response) => {
      this.traslateService.maptoAtelier(response, this.series1);
      //console.log(this.series1);
    });

    //this.getUserr()

    this.executeFunction();
  }
  pageChanged(event) {
    this.spinnerevents.show();
    this.showevents = true;
    console.log("spinner",this.showevents)
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }
  getNextData(currentSize, offset, limit) {
    this.showevents = true;
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.offsetPagination = parseInt(offset)+1;

    let getUrl="";
    if (this.withFiltre){
      getUrl=environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/maneuvers/filter/" +
        encodeURI(JSON.stringify(this.registerForm.value))+ '?page='+ this.offsetPagination;
    }
    else{
      getUrl=
        environment.apiUrl +
        "/companies/" +
        JSON.parse(localStorage.getItem("currentUser")).company_id +
        "/maneuvers"+'?page='+ this.offsetPagination;
    }
    this.http.get(getUrl, requestOptions)
    .subscribe((response) => {
      this.spinnerevents.hide();
      this.list.length = currentSize;
      // @ts-ignore
      console.log("page",response);
       // @ts-ignore
      this.list.push(...response.data);
      // @ts-ignore
      this.list.length = response.total;
      this.dataSource = new MatTableDataSource<any>(this.list);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
      this.showevents = false;
});
  }
  dbClickitem(e, i, t, m, typeEvenement, event) {
    //console.log('jhjkhjk' + e)
    /*  let url = 'user/events/details'
     this.router.navigate([url]); */
    //console.log(i)
    localStorage.setItem("id_Vehicule", i);
    localStorage.setItem("id_manoeuvre", m);
    localStorage.setItem("filterValue", typeEvenement);
    event.from='event';
    localStorage.setItem('trajet_history', JSON.stringify(event));
    this.router.navigate(["user/vehicule/trajet/" + t]);
    console.log('event:',event)
  }

  openSnackBar() {
    this._snackBar.open("Cannonball!!", "End now", {
      duration: 500,
    });
  }

  applyFilterr() {
    this.dataSource.filter = "" + Math.random();
  }

  getFilter() {
    this.range = (<HTMLInputElement>document.getElementById("dateTime")).value;
    //console.log(this.range.split(',')[0].split('/')[2])    //var firstD =this.range.split('~')[0].split(',')[0]
    var firstD = "9/23/2016";
    var firstT = this.range.split("~")[0].split(",")[1].split(" ")[1];
    //   var secondD = this.range.split('~')[1].split(',')[0]
    var secondD = "9/23/2020";
    var secondT = this.range.split("~")[1].split(",")[1].split(" ")[1];
    var filterDT = firstD + "--" + secondD;
    this.pipe = new DatePipe("en");
    //console.log(new Date(firstD).getUTCDate())
    var e = new Date(firstD).getUTCDate();
    //console.log(e)
    this.filterValue = filterDT.replace(/\s/g, "");

    const defaultPredicate = this.dataSource.filterPredicate;
    //console.log(this.range + "range")
  }

  executeFunction() {
    //console.log(this.rangeForm)

    this.addNewDate(this.rangeForm);
  }

  addNewDate(e) {
    var DateStart = new Date(e.value.start)?.toString().split("(")[0];
    //this.minDate = new Date(e.value.start)

    var DateEnd2 = new Date(e.value.end)?.toISOString();
    var DateEnd = new Date(e.value.end)?.toString().split("(")[0];
    //console.log(DateEnd2, DateStart, DateEnd)
    this.dateFiltrer = DateStart + "~" + DateEnd;
    if (DateEnd2 != "1970-01-01T00:00:00.000Z") {
      localStorage.setItem(
        "startDateValue",
        new Date(this.rangeForm.value.start).toString()
      );
      localStorage.setItem(
        "endDateValue",
        new Date(this.rangeForm.value.end).toString()
      );
    } else {
      // this.rangeForm.reset();
    }
  }
  SubaddNewDate(e) {
    var DateStart = new Date(e.value.start)?.toString().split("(")[0];
    //this.minDate = new Date(e.value.start)

    var DateEnd2 = new Date(e.value.end)?.toISOString();
    var DateEnd = new Date(e.value.end)?.toString().split("(")[0];
    //console.log(DateEnd2, DateStart, DateEnd)
    this.dateFiltrer = DateStart + "~" + DateEnd;
    if (DateEnd2 != "1970-01-01T00:00:00.000Z") {
      localStorage.setItem(
        "startDateValue",
        new Date(this.rangeForm.value.start).toString()
      );
      localStorage.setItem(
        "endDateValue",
        new Date(this.rangeForm.value.end).toString()
      );

      this.submitForm();
    } else {
      // this.rangeForm.reset();
    }
  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    filter: [],
    dallas: [],
    driver_name: [],
    unit_id: [],
    plate: [],
    unit_type: [],
    unit_type2: [],
    safety_score_min: this.minValue,
    safety_score_max: this.maxValue,
    maneuver_type: [],
    maneuver_type2: [],
  });

  submitForm() {
    var date1: any = this.dateFiltrer.replace("GMT+0100", "");
    // tslint:disable-next-line:member-ordering
    this.registerForm.controls["filter"].setValue(
      date1.replace("GMT+0100", "")
    );
    var List: any = [];
    //console.log(this.registerForm?.controls['unit_type2']?.value)
    for (
      let index = 0;
      index < this.registerForm?.controls["unit_type2"]?.value?.length;
      index++
    ) {
      var json: any = this.registerForm?.controls["unit_type2"]?.value;
      List.push(json[index].value);
    }

    this.registerForm.controls["unit_type"].setValue(List);
    switch (this.registerForm?.controls["maneuver_type2"]?.value) {
      case 1:
        this.registerForm.controls["maneuver_type"].setValue(2);
        break;
      case 2:
        this.registerForm.controls["maneuver_type"].setValue(6);
        break;

      case 3:
        this.registerForm.controls["maneuver_type"].setValue(7);
        break;

      case 4:
        this.registerForm.controls["maneuver_type"].setValue(8);
        break;

      case 5:
        this.registerForm.controls["maneuver_type"].setValue(9);
        break;
      case 6:
        this.registerForm.controls["maneuver_type"].setValue(10);
        break;
      case 7:
        this.registerForm.controls["maneuver_type"].setValue(13);
        break;
      case 8:
        this.registerForm.controls["maneuver_type"].setValue(15);
        break;
      case 9:
        this.registerForm.controls["maneuver_type"].setValue(16);
        break;
      default:
        break;
    }

    delete this.registerForm.value.unit_type2;
    delete this.registerForm.value.maneuver_type2;
    //console.log(this.registerForm.value)
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    var URL: any =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/maneuvers/filter/ " +
      encodeURI(JSON.stringify(this.registerForm.value))+'?page=1';
    this.typeEvenement = false;

    this.showevents = true;
    this.spinnerevents.show();
    this.http.get(URL, requestOptions).subscribe(
      (response : any) => {
        this.itemSelect = [];
        var list: any = response;
        this.hiddenDetails = false;
        this.selectedRowIndex = -1;
        list.data.length=response.total;
        this.dataSource = new MatTableDataSource(list.data);
        this.refModel.close()

        this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort;
         this.lengthTotal = response.total

        this.collection = [];
        //console.log(list.length)

        var lgn: any = list.length;
        this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize);

        //console.log(this.lengthpage)

        if (this.lengthpage % 2 == 0) {
          for (var i = 0; i < this.lengthpage; i++) {
            this.collection.push(i + 1);
          }
        } else {
          for (var i = 0; i < this.lengthpage + 1; i++) {
            this.collection.push(i + 1);
          }
        }

        this.spinnerevents.hide();
        this.showevents = false;
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });

        this.spinnerevents.hide();
        this.showevents = false;
      }
    );
  }

  resetValue() {
    this.registerForm?.controls["dallas"]?.reset();
    this.registerForm?.controls["driver_name"]?.reset();
    this.registerForm?.controls["unit_id"]?.reset();
    this.registerForm?.controls["plate"]?.reset();
    this.registerForm?.controls["unit_type2"]?.reset();
    this.registerForm?.controls["safety_score_min"]?.reset();
    this.registerForm?.controls["maneuver_type2"]?.reset();
    this.registerForm?.controls["maneuver_type"]?.reset();
    this.rangeForm = new FormGroup({
      start: new FormControl(new Date()),
      end: new FormControl(new Date()),
    });

    var maxValue: any = 100;
    this.registerForm.controls["safety_score_max"].setValue(maxValue);
    this.getUserrefrech(15,1);
  }

  updateColor(progress) {
    if (progress < 55) {
      return "#dc3545";
    } else if (progress > 75) {
      return "#28a745";
    } else {
      return "#fd8021";
    }
  }

  resetFilter() {
    this.rangeForm.reset();

    (<HTMLInputElement>document.getElementById("getdt")).value = "";

    document.getElementById("getdt").autofocus = false;
    this.getUserrefrech(15,1);
    //this.executeFunction()
  }

  getFilterChoise(filterdte) {
    this.pipe = new DatePipe("en");
    this.days = this.pipe.transform(new Date(), "M/d/yyyy");
    //console.log(this.days)

    var date = new Date();
    date.setDate(date.getDate() - filterdte);

    this.finalDate =
      date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    //console.log('mmm' + this.finalDate)

    this.filterValue = this.days;
    var periodeFilter =
      date.toString().substr(0, 24) +
      " ~ " +
      new Date().toString().substr(0, 24);
    this.dataSource.filterPredicate = (data, filter) => {
      return (
        new Date(data.created_at) >= new Date(this.finalDate) &&
        new Date(data.pushed_at) <= new Date(this.days)
      );
    };
    this.dataSource.filter = "" + Math.random();

    this._snackBar.open(
      "Filtrage periode effectuer : " + periodeFilter,
      "close",
      {
        duration: 2500,
      }
    );
  }

  selectedRowIndex = -1;

  getItemDetails(e) {
    this.itemSelect = e;
    //console.log(e)
    this.selectedRowIndex = e.id;
    this.hiddenDetails = true;
  }

  selectedRowIndex2 = -1;

  getItemDetails2(e) {
    this.itemSelect2 = e.forks;
    //console.log(e)

    this.selectedRowIndex2 = e.id;
    this.hiddenContenu = "jkhjk";
  }
  gettbldetils() {
    this.tblhidden = "true";
  }
  gettbldetilsd() {
    this.tblhidden = "jjj";
  }
  // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  item = "item";
  collection: any;

  // public updateManualPage2(index2): void {
  //   this.collection = [];

  //   this.paginator.pageSize = index2;

  //   this.paginator.page.next({
  //     pageIndex: this.paginator.pageIndex,
  //     pageSize: this.paginator.pageSize,
  //     length: this.paginator.length,
  //   });

  //   this.lengthpage = parseInt("" + this.paginator.length / index2);


  //   for (var i = 0; i < this.lengthpage; i++) {
  //     this.collection.push(i + 1);
  //   }

  // }

  applyFilterer(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter la table type ." + e2 + " ?",
      showCancelButton: true,
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "Le fichier est exporté.");
        //console.log(e);
        e.exportTable(e2, {
          fileName: "STG_DRIVE_Evenement_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE Evenement",
          Props: { Author: "STG_DRIVE" },
        });
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire("Annuler", "Fichier non exporté !!");
      }
    });
  }

  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l\'exportation!",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        EventsUtils.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annulé", "Fichier non exporté !!");
      }
    });
  }
}

export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}
